import getConfig from "next/config";

import Breadcrumbs from "@components/Breadcrumbs";
import InStoreCreditRequestForm from "@components/FinancingSolutions/InStoreCreditRequestForm";
import Heading from "@components/Heading";

const {
  publicRuntimeConfig: { settings, content },
} = getConfig();

const InStoreConsumerCreditContainer = () => (
  <>
    <Breadcrumbs
      breadcrumbs={[
        {
          id: 1,
          level: 2,
          name: "Solutii de finantare",
          url_key: "solutii-finantare/",
        },
        {
          id: 1,
          level: 99,
          name: "Credit de consum",
        },
      ]}
    />

    <img
      src={`${settings.websiteStatics}/images/credex/banner-credit-consum-traditional.png?randomisrandomagainlas`}
      alt=""
      className="mt-6 lg:mt-0 w-full rounded-bl-xl rounded-tr-xl"
    />

    <div className="lg:flex flex-wrap lg:flex-nowrap lg:w-5/6 lg:px-2 mx-auto mt-8 lg:mt-12">
      <article className="w-full lg:grow md:pr-10 text-sm lg:pt-6 pb-4 lg:pb-0">
        <Heading
          as="h1"
          display="h1"
          title="Creditul de bunuri"
          classesProp="mb-4 lg:mb-2"
        />
        <p className="mb-4 lg:mb-6">
          Sunt lucruri de care ai nevoie acum, lucruri importante, care nu pot
          fi puse pe lista de asteptare. Si nici nu trebuie.
        </p>
        <p className="mb-4">
          Ai la indemana Creditul de bunuri, cu ajutorul caruia poti lua azi tot
          ce ai nevoie din magazinele {content.websiteTitle}, USOR, in RATE
          EGALE.
        </p>
        <strong>Oferta noastra</strong>
        <ul className="list-disc ml-5 mb-4 leading-loose">
          <li>
            Valoarea cumparaturilor pentru care poti obtine finantare:
            <br /> poti imprumuta intre 500 - 24,000 lei
          </li>
          <li>
            Perioadele pe care le poti selecta pentru rambursarea sumei
            imprumutate:
            <br /> 12-36 de luni
          </li>
        </ul>
        Cum functioneaza:
        <ol className="list-decimal ml-5 mb-4 leading-loose">
          <li>
            <strong>Alegi produsele dorite</strong> din orice magazin{" "}
            {content.websiteTitle}
          </li>
          <li>
            <strong>Aplici pentru un credit: direct in magazin</strong> la
            Biroul Credex
          </li>
          <li>
            Dupa aprobare, semnezi documentatia de creditare si poti sa pleci
            acasa, in aceeasi zi, cu bunurile achizitionate in rate.
          </li>
        </ol>
        Care sunt avantajele tale:
        <ul className="list-disc ml-5 mb-4 leading-loose">
          <li>
            <strong>RAPIDITATE</strong>: Primesti raspuns PE LOC*
          </li>
          <li>
            <strong>SIMPLITATE</strong>: Aplici direct in magazin, doar cu actul
            de identitate (in anumite conditii)*
          </li>
          <li>
            <strong>ZERO EFORT</strong>: Nu este necesar avans sau garantii
            suplimentare
          </li>
          <li>
            <strong>COMODITATE</strong>: Platesti ratele ulterior direct in
            magazin, la casa de marcat, pe baza codului de bare (il gasesti pe
            tichetul de plata sau pe graficul de rambursare)
          </li>
        </ul>
        <p className="text-[14px] font-semibold">
          *aplicabil pentru categoriile de persoane (cu titlu de exemplu:
          salariati) pentru care exista obligatii legale de declarare a
          veniturilor la autoritatile fiscale, in baza exprimarii acordului de
          consultare si prelucrare a informatiilor din bazele de date ale
          Ministerului Finantelor Publice, Agentia Nationala de Administrare
          Fiscala (ANAF). Pentru celelalte categorii de venituri, este necesara
          prezentarea documentatiei de venit
        </p>
      </article>

      <article className="px-4 lg:px-0 lg:w-480px flex-none -mx-15px lg:-mx-4 py-6 text-sm bg-newGray-light lg:rounded-tr-lg lg:rounded-bl-lg">
        <Heading
          as="h1"
          display="h1"
          title="Formular contact"
          classesProp="mb-1 lg:px-10"
        />
        <p className="mb-4 lg:px-10 leading-20">
          Completeaza datele de mai jos si vei fi contactat in cel mai scurt
          timp
        </p>

        <div className="border-gray-1100 border-t mt-6 nd:mt-10 pt-6 lg:px-10">
          <InStoreCreditRequestForm />
        </div>
      </article>
    </div>

    <div className="lg:flex flex-wrap lg:flex-nowrap items-center mt-10">
      <article className="mt-10">
        <Heading
          as="h1"
          display="h1"
          title="Exemplu reprezentativ"
          classesProp="mb-4"
        />
        <p className="mb-6">
          Exemplu reprezentativ de calcul, produs cu asigurare de viata atasat:{" "}
          <strong>In cazul Creditului</strong> Standard 18M/ 24M / Low DAE 48M{" "}
          <strong>
            (ca urmare a indeplinirii criteriilor de eligibilitate) in valoare
            de 1.000 / 4.000 / 4.500 Lei cu asigurare de viata cu prima de
            asigurare unica finantata* de 90 / 480 / 1.080 Lei, adaugata la
            valoarea creditului, rezultand o valoare totala imprumutata 1.090 /
            4.480 / 5.580 Lei pe 18 / 24 / 48 de luni: rata anuala a dobanzii
            anuale fixa este de 44,5% / 44,5% / 21,5%, comision de analiza dosar
            0 Lei, comision lunar de administrare credit 10 Lei, valoarea ratei
            lunare 96,98 / 304,98 / 187,26 Lei (pentru rate egale, rata
            incluzand si costul asigurarii de viata cu prima finantata),
            valoarea totala platibila 1.745,64 / 7.319,39 / 8.988,36 Lei, DAE
            90,29% / 67,02% / 28,98% (calculat la valoarea totala imprumutata de
            1.090 / 4.480 / 5.580 Lei).{" "}
          </strong>
          <br />
          <span className="italic">
            *Prima unica de asigurare de viata finantata de Imprumutator este
            calculata ca procent de 0,5% din valoarea creditului de 1.000 /
            4.000 / 4.500 Lei si inmultita cu perioada de creditare de 18 / 24 /
            48 de luni. Costul finantarii de catre Imprumutator a primei unice
            de asigurare de viata este 39,28 / 278,59 / 566,70 Lei, calculat
            prin aplicarea ratei dobanzii de 44,5% / 44,5% / 21,5%, la valoarea
            din credit reprezentand prima unica de asigurare de 90 / 480 / 1.080
            Lei finantata de Imprumutator, rezultand o valoare imprumutata de
            1.090 / 4.480 / 5.580 Lei.
          </span>
        </p>

        <p>
          Exemplu reprezentativ de calcul, produs fara asigurare de viata
          atasat: <strong>In cazul Creditului</strong> Standard 18M / 24M / 36M/
          Low DAE 48M{" "}
          <strong>
            (ca urmare a indeplinirii criteriilor de eligibilitate) pentru o
            valoare totala a creditului de 1.000 / 4.000 / 6.000 / 4.500 Lei pe
            18 / 24 / 36 / 48 de luni: rata dobanzii fixa / an este de 52,5% /
            52,5% / 52,5% / 29,5%, comision de analiza dosar 0 Lei, comision
            lunar de administrare credit 10 Lei, valoarea ratei lunare 94,72 /
            293,56 / 366,20 / 174,45 Lei (pentru rate egale), valoarea totala
            platibila 1.704,91 / 7.045,36 / 11.408,33 / 8.373,49 Lei, DAE
            109,07% / 82,27% / 59,67% / 40,73%.
          </strong>
        </p>
      </article>
    </div>
  </>
);

export default InStoreConsumerCreditContainer;
